export const WHATSAPP_NUMBER = "917736225610";
export const WHATSAPP_DISPLAY = "+91 77362 25610";
export const LOGO_URL =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_harvest-hub-822/artifacts/ne8pputl_40xleaves_logo_transparent_749b2524.png";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Microgreens", path: "/microgreens" },
  { label: "Plans", path: "/plans" },
  { label: "Franchise", path: "/franchise" },
  { label: "FAQ", path: "/faq" },
  { label: "Founders", path: "/founders" },
  { label: "Contact", path: "/contact" },
];

export const HOW_IT_WORKS = [
  {
    n: "01",
    title: "Message us on WhatsApp",
    body: "Share your pincode, and we connect you to the 40X Leaves grower in your area.",
  },
  {
    n: "02",
    title: "Pick your plan",
    body: "Weekly deliveries of fresh-harvested microgreens, sized for your household.",
  },
  {
    n: "03",
    title: "Eat fresh",
    body: "Harvested hours before delivery, not days. No cold chain, no long transport, no wilted greens.",
  },
];

export const TRUST_STRIP = [
  "Grown hyperlocally in your pincode",
  "Harvested the same day as delivery",
  "Subscription managed entirely on WhatsApp",
  "Backed by trained, certified franchise growers",
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Our Story",
    body: "40X Leaves Microgreens Private Limited was founded on a simple observation: the freshest, most nutrient-rich food in the world loses most of its value in transit. Microgreens are at their peak within hours of harvest — so instead of building one big farm and shipping across the state, we build many small farms, one in every neighbourhood.",
  },
  {
    n: "02",
    title: "Our Model",
    body: "We train and equip local entrepreneurs to run compact microgreen farm units in their own territory. Every unit serves its own pincode area — which means your greens are grown minutes from your kitchen, by someone from your own community.",
  },
  {
    n: "03",
    title: "Our Mission",
    body: "To make dense nutrition an everyday habit in every Indian household — affordable, fresh, and hyperlocal.",
  },
];

export const VALUES = [
  {
    title: "Freshness without compromise",
    body: "Same-day harvest to delivery. Hours, not days.",
  },
  {
    title: "Local livelihoods",
    body: "Every subscription supports a neighbourhood entrepreneur.",
  },
  {
    title: "Radical simplicity",
    body: "No apps to download; your entire relationship with us lives on WhatsApp.",
  },
  {
    title: "Transparency",
    body: "You know your grower by name.",
  },
];

export const MICROGREENS = [
  { name: "Radish", note: "Peppery crunch, rich in vitamin C and antioxidants" },
  { name: "Sunflower", note: "Nutty and crisp, high in protein and healthy fats" },
  { name: "Pea Shoots", note: "Sweet and tender, packed with vitamins A, C, and folate" },
  { name: "Mustard", note: "Bold and spicy, loaded with glucosinolates" },
  { name: "Fenugreek", note: "Earthy, traditional, great for everyday cooking" },
  { name: "Beetroot", note: "Vibrant colour, rich in iron and nitrates" },
  { name: "Amaranth", note: "Striking red leaves, calcium and iron dense" },
];

export const PLANS = [
  {
    name: "Starter",
    tag: "For first-timers",
    description: "A taste of fresh — ideal for individuals or first-timers.",
    features: ["Weekly delivery of fresh-harvested microgreens", "Rotating variety selection"],
    highlight: false,
  },
  {
    name: "Family",
    tag: "Most popular",
    description: "Our most popular plan — enough greens for daily use.",
    features: ["Multiple varieties per delivery", "Weekly delivery, flexible pause anytime"],
    highlight: true,
  },
  {
    name: "Wellness Plus",
    tag: "Maximum nutrition",
    description: "For serious nutrition — maximum variety and volume.",
    features: ["Full variety range each week", "Priority harvest slot"],
    highlight: false,
  },
];

export const PLAN_PERKS = [
  "Pause or resume anytime on WhatsApp",
  "Secure online payment (Razorpay)",
  "Same-day harvest guarantee",
  "Direct line to your grower",
];

export const WHY_FRANCHISE = [
  {
    title: "Exclusive territory",
    body: "You own your pincode area; every customer in it is yours.",
  },
  {
    title: "Majority revenue share",
    body: "You keep the larger share of every subscription, settled automatically to your bank account after every payment — no waiting for monthly payouts.",
  },
  {
    title: "Complete tech stack",
    body: "Franchise mobile app for deliveries, sowing plans, batches, earnings, and customer management. HQ handles the platform.",
  },
  {
    title: "WhatsApp-native customers",
    body: "We bring the demand system; customers in your territory route directly to you.",
  },
  {
    title: "Full training & SOPs",
    body: "Growing protocols, harvest schedules, and a supply line for seeds, trays, and consumables.",
  },
  {
    title: "Low footprint",
    body: "Units run in compact indoor spaces; no farmland required.",
  },
];

export const FRANCHISE_STEPS = [
  { n: "01", title: "Apply", body: "Tell us your pincode." },
  { n: "02", title: "Territory check", body: "Territory check & discussion." },
  { n: "03", title: "Training + setup", body: "Training and unit setup." },
  { n: "04", title: "Go live", body: "Customers in your pincode start routing to you." },
];

export const FAQS = [
  {
    q: "What exactly are microgreens?",
    a: "Young vegetable greens harvested 7–14 days after germination — the stage at which nutrient density is at its peak, often many times higher than the mature plant.",
  },
  {
    q: "How do I subscribe?",
    a: "Just message us on WhatsApp with your pincode. No app downloads, no signup forms.",
  },
  {
    q: "What if there's no grower in my area yet?",
    a: "You'll be added to our waitlist for your pincode — and you'll be the first to know when a unit opens. High-demand pincodes get new units fastest, so tell your neighbours!",
  },
  {
    q: "How fresh are the greens, really?",
    a: "Harvested on the morning of your delivery, by a grower located in your own area. Hours, not days.",
  },
  {
    q: "Can I pause my subscription when I travel?",
    a: "Yes — pause and resume anytime with a WhatsApp message.",
  },
  {
    q: "How do payments work?",
    a: "Securely online via Razorpay, through a link sent on WhatsApp. No cash handling needed.",
  },
  {
    q: "Are the greens grown with pesticides?",
    a: "No. Microgreens grow in a short, controlled indoor cycle that doesn't require pesticides.",
  },
  {
    q: "I want to start a unit — what does it cost?",
    a: "Franchise investment details are shared during the application discussion. Message us or use the franchise application form to start.",
  },
];

export const FOUNDERS = [
  {
    name: "Shaikha",
    role: "Founder & Director",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_harvest-hub-822/artifacts/dmmi4ikn_WhatsApp%20Image%202026-07-22%20at%2012.12.23.jpeg",
    bio: "Shaikha is the founder and driving vision of 40X Leaves. She built the company around a conviction: that dense nutrition shouldn't be a luxury import — it should be grown in every neighbourhood, by people from that neighbourhood. As Director, she leads the company's growing operations, franchise partnerships, and quality standards, shaping 40X Leaves from a single unit into a growing hyperlocal farming network across Kerala.",
    quote: "Every pincode deserves its own farm.",
  },
  {
    name: "Harikrishnan Kalarikkal Joshi",
    role: "Co-founder, COO & CTO",
    image: "https://customer-assets-eiarnc6j.emergentagent.net/job_harvest-hub-822/artifacts/aad2otrq_hari.jpg",
    bio: "Hari is a serial entrepreneur and published author (The Brain Code Framework) with a track record across edtech, startup consulting, and technology ventures — including building and exiting funded startups. At 40X Leaves he architects the entire platform: the WhatsApp-native customer experience, the franchisee mobile app, the HQ operations system, and the automated revenue-settlement engine that pays franchise partners instantly.",
    quote: "Franchisees shouldn't chase payouts or paperwork. The system should do it for them.",
  },
];

export const HERO_VIDEO_WEBM =
  "https://res.cloudinary.com/bjoujent/video/upload/w_1600,q_auto/Untitled_design_14_un9b9i.webm";
export const HERO_VIDEO_MP4 =
  "https://res.cloudinary.com/bjoujent/video/upload/w_1920,q_auto:good/Untitled_design_14_un9b9i.mp4";

export const IMAGES = {
  heroProduct: "https://images.unsplash.com/photo-1758702087578-46d7eacfb9ca",
  peaShoots: "https://images.unsplash.com/photo-1774887248684-64162fde322b",
  sprouting: "https://images.pexels.com/photos/1002703/pexels-photo-1002703.jpeg",
  hands: "https://images.unsplash.com/photo-1597868165956-03a6827955b1",
  soil: "https://images.unsplash.com/photo-1709538276836-11918baf4a29",
};
